var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"modal-container standard loader"},[_c('div',[_c('div',{staticClass:"header-rainbow"}),_c('PromptHeader',{attrs:{"step":_vm.step}}),_c('main',[_c('div',[_c('LoaderImg')],1)])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }